<template>
  <div>
    <h2>List page</h2>
    <p>
        This is the initial page. You'll see this page when navigate
        to Vue section from navbar.
    </p>
  </div>
</template>

<script>
export default {
  name: 'List',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
